import { Flex } from 'foundations-components/components/Flex';
import styled, { useTheme } from 'styled-components';

/* @bend-expect trellis-tokenized */
import { jsx as _jsx } from "react/jsx-runtime";
const SkeletonSpan = styled.span.withConfig({
  displayName: "SkeletonBase__SkeletonSpan",
  componentId: "jc9ceg-0"
})(({
  height,
  width,
  shape,
  theme
}) => ({
  background: 'var(--bg-color)',
  height,
  width,
  borderRadius: shape === 'circle' ? '50%' : '0.25rem',
  overflow: 'hidden',
  position: 'relative',
  userSelect: 'none',
  zIndex: 1 /* Necessary for overflow: hidden to work correctly in Safari */,

  ['@keyframes loading-skeleton']: {
    '100%': {
      transform: 'translateX(5%)'
    }
  },
  '&::after': {
    animation: 'loading-skeleton 2s ease-in-out infinite',
    backgroundImage: 'var(--highlight-gradient)',
    backgroundRepeat: 'no-repeat',
    display: 'var(--animation-display)',
    position: 'absolute',
    transform: 'translateX(-100%)',
    top: theme.space['0'],
    left: theme.space['0'],
    right: theme.space['0'],
    height: '200%',
    width: '400%',
    zIndex: 100,
    content: `' '`
  },
  [`@media (prefers-reduced-motion)`]: {
    '--animation-display': 'none' /* Disable animation */
  },
  [`--highlight-gradient`]: `linear-gradient(-45deg, #ffffff00 35%, ${theme.color['border-core-subtle']} 50%, #ffffff00 65%)`,
  [`--bg-color`]: `linear-gradient(99deg, ${theme.color['fill-tertiary-pressed']}, ${theme.color['border-core-pressed']})`
}));
const SkeletonBase = ({
  height,
  width = '100%',
  shape = 'rect',
  circleSize,
  wrapperWidth = '100%',
  marginStyle,
  'data-test-id': dataTestId = 'skeleton-loading'
}) => {
  const theme = useTheme();
  return /*#__PURE__*/_jsx(Flex, Object.assign({
    inlineSize: wrapperWidth
  }, marginStyle, {
    children: /*#__PURE__*/_jsx(SkeletonSpan, {
      "aria-busy": true,
      role: "status",
      height: shape === 'circle' ? circleSize : height,
      width: shape === 'circle' ? circleSize : width,
      shape: shape,
      theme: theme,
      "data-test-id": dataTestId,
      children: "\u200C"
    })
  }));
};
export default SkeletonBase;